import styled from "styled-components";

export const UserButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 220px;
  height: 34px;
  padding: 0 12px;
  border: 1px solid ${({ theme }) => theme.colors.inputBorder};
  border-radius: 999px;
  background: ${({ theme }) => theme.colors.lightGrey};
  color: ${({ theme }) => theme.colors.textSecondary};
  font-size: ${({ theme }) => theme.typography.body.fontSize};
  cursor: pointer;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: ${({ theme }) => theme.shadow.medium};
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 0.2rem ${({ theme }) => theme.colors.primary};
  }

  i {
    color: ${({ theme }) => theme.colors.secondary};
  }
`;

export const UserName = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media screen and (max-width: 1100px) {
    display: none;
  }
`;

export const MenuHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 0.6rem 1rem;
  max-width: 260px;
`;

export const MenuHeaderName = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text};
  overflow-wrap: anywhere;
`;

export const MenuHeaderEmail = styled.span`
  font-size: ${({ theme }) => theme.typography.small.fontSize};
  color: ${({ theme }) => theme.colors.textSecondary};
  overflow-wrap: anywhere;
`;

export const MenuHeaderRoles = styled.span`
  font-size: ${({ theme }) => theme.typography.small.fontSize};
  color: ${({ theme }) => theme.colors.darkGrey};
`;
